export default {
    pleaseSelect: "请选择",
    salaryUnit: "越南盾",
    negotiated: "面议",
    lessThanFiveMillion: "低于5百万",
    unit: "百万",
    moreThanFiftyMillion: "高于50百万",
    salaryRangePrefix: "至",
};
